import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { Outlines, SidebarProps } from '../../types/presentationView'
import { toast } from 'react-toastify'
import { FaCheck, FaExclamation, FaTimes } from 'react-icons/fa'
import './viewpresentation.css'
import { PricingModal } from '../shared/PricingModal'
import GuidedTour from '../onboarding/shared/GuidedTour'
import GuidedTourMobile from '../onboarding/shared/GuidedTourMobile'
// import crypto from 'crypto'
import { Theme } from '../../lib/theme';
const Sidebar: React.FC<SidebarProps> = ({
  onOutlineSelect,
  selectedOutline,
  newSlideGenerated,
  fetchedOutlines,
  documentID,
  fetchOutlines,
  isLoading,
  isDisabled,
  userPlan,
  monthlyPlanAmount,
  yearlyPlanAmount,
  currency,
  yearlyPlanId,
  monthlyPlanId,
  authToken,
  orgId,
  isNewSlideLoading,
  subscriptionId,
  selectedOutlineID,
}) => {
  const [outlines, setOutlines] = useState<Outlines[]>([])
  const [hoverIndex, setHoverIndex] = useState<number | null>(null)
  const [inputIndex, setInputIndex] = useState<number | null>(null)
  const [newOutline, setNewOutline] = useState<string>('')
  const outlineRefs = useRef<(HTMLLIElement | null)[]>([])
  const [newOutlineLoading, setNewOutlineLoading] = useState(false)
  const [isDialogVisible, setIsDialogVisible] = useState(false)
  const [isPricingModalOpen, setIsPricingModalOpen] = useState(false)
  const [hasVisited, setHasVisited] = useState(false)

  const generateOutlineID = () => {
    return `outlineID-${window.crypto.randomUUID()}`
  }

  // Retrieve `hasVisited` from local storage on mount
  useEffect(() => {
    const visited = localStorage.getItem('hasVisited') === 'true'
    setHasVisited(visited)
  }, []) // Runs only once when the component mounts

  useEffect(() => {
    setOutlines(fetchedOutlines)
  }, [fetchedOutlines])

  // Scroll to the selected outline and ensure it is visible in the sidebar
  useEffect(() => {
    if (selectedOutlineID) {
      const selectedIndex = outlines.findIndex(
        (outline) => outline.outlineID === selectedOutlineID
      )
      const selectedRef = outlineRefs.current[selectedIndex]

      if (selectedRef) {
        selectedRef.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest',
        })
      }
    }
  }, [selectedOutlineID, outlines])

  const handleAddOutline = async (index: number) => {
    const newOutlineID = generateOutlineID()

    setNewOutlineLoading(true)
    if (!newOutline.trim()) {
      console.log('New outline is empty')
      setNewOutlineLoading(false)
      return
    }
    const updatedOutline = { title: newOutline }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/outline/blocklist/insert`,     
        {
          documentId: documentID,
          title: updatedOutline.title,
          position: index + 1,
          outlineID: newOutlineID,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      )
      // if(response.status===404){
      //   toast.error('Upgrade to add more slides', {
      //     position: 'top-right',
      //     autoClose: 3000,
      //   })
      //   return ;
      // }
      const result = response.data
      if (result.title && result.type) {
        // Retrieve the existing outlineIDs array from sessionStorage
        const storedOutlineIDs = sessionStorage.getItem('outlineIDs')
        let outlineIDs = storedOutlineIDs ? JSON.parse(storedOutlineIDs) : []

        // Add the new outlineID to the array
        outlineIDs.push(newOutlineID)

        // Save the updated array back to sessionStorage
        sessionStorage.setItem('outlineIDs', JSON.stringify(outlineIDs))
        toast.success('Outline Successfully Added', {
          position: 'top-right',
          autoClose: 3000,
        })
        fetchOutlines()
        setNewOutlineLoading(false)
      }
      setInputIndex(null)
      setNewOutline('')
    } catch (error:any) {
      if (error.response && error.response.status === 404) {
        toast.error('Upgrade to add more slides', {
          position: 'top-right',
          autoClose: 3000,
        })
      } else {
        toast.error('Error adding outline', {
          position: 'top-right',
          autoClose: 3000,
        })
      }
      console.error('Error adding outline:', error)
      setNewOutlineLoading(false)
    }
  }

  return (
    <div
    className="no-scrollbar no-scrollbar::-webkit-scrollbar hidden lg:block w-[22%] h-[85%] p-4 ml-4 rounded-xl border overflow-y-auto"
    style={{
      backgroundColor: Theme.colors.secondary,
      borderColor: Theme.colors.stroke.weak,
    }}
  >
  
      {isLoading && (
 <div className="w-full h-full flex items-center justify-center">
 <div
   className="w-10 h-10 border-4 rounded-full animate-spin"
   style={{
     borderTopColor: Theme.colors.primary,
     borderColor: Theme.colors.stroke.weak,
   }}
 ></div>
</div>

      )}
      <ul className="space-y-2 relative">
        {outlines.map((outline, idx) => (
          <React.Fragment key={outline._id}>
            <li
              ref={(el) => (outlineRefs.current[idx] = el)}
              className="relative group"
              onMouseEnter={() => setHoverIndex(idx)}
              onMouseLeave={() => setHoverIndex(null)}
            >
              {/* Outline Title */}
              <button
  onClick={() => onOutlineSelect(outline.outlineID)}
  className={`w-full max-w-xs font-normal text-left p-2 rounded-lg flex justify-between ${
    selectedOutlineID === outline.outlineID
      ? 'text-primary bg-blue-50'
      : 'hover:bg-gray-200'
  }`}
  style={{
    color:
      selectedOutlineID === outline.outlineID
        ? Theme.colors.primary
        : Theme.colors.text.weak,
  }}
>

                <span>{`${idx + 1}. ${outline.title}`}</span>
                {isNewSlideLoading[outline.outlineID] && (
       <div className="flex items-center justify-center ml-2 mt-1">
       <div
         className="w-5 h-5 border-4 border-gray-300 rounded-full animate-spin"
         style={{ borderTopColor: Theme.colors.primary }}
       ></div>
     </div>
     
                )}
                {newSlideGenerated[outline.outlineID] === 'Yes' &&
                  !isNewSlideLoading[outline.outlineID] && (
                    <div className="flex items-center justify-center ml-2 mt-1">
                    <div className="w-5 h-5">
                      <FaCheck style={{ color: Theme.colors.button.primary }} />
                    </div>
                  </div>
                  
                  )}
                {newSlideGenerated[outline.outlineID] === 'No' &&
                  !isNewSlideLoading[outline.outlineID] && (
                    <div className="flex items-center justify-center ml-2 mt-1">
                    <div className="w-5 h-5">
                      <FaExclamation style={{ color: Theme.colors.error }} />
                    </div>
                  </div>                  
                  )}
              </button>

              {/* + Button */}
              <div
                className={`mt-2 flex items-center justify-center space-x-4 relative ${
                  (idx === 0 && !hasVisited) || hoverIndex === idx
                    ? ''
                    : 'hidden group-hover:flex'
                }`}
              >
                {/* Left Line */}
                <div className="flex-grow h-px" style={{ backgroundColor: Theme.colors.stroke.weak }}></div>

                {/* Circular + Icon */}
                <div
                  className="relative"
                  onMouseEnter={() => {
                    if (
                      (isDisabled && userPlan === 'free') ||
                      userPlan !== 'free'
                    )
                      setIsDialogVisible(true)
                  }}
                  onMouseLeave={() => {
                    if (
                      (isDisabled && userPlan === 'free') ||
                      userPlan !== 'free'
                    )
                      setIsDialogVisible(false)
                  }}
                >
          <button
  id={idx === 0 ? 'outline' : undefined}
  className="w-8 h-8 flex items-center justify-center rounded-full border transition duration-200"
  onClick={() => setInputIndex(idx)}
  style={{
    backgroundColor: Theme.colors.secondary,
    color: Theme.colors.text.weak,
    borderColor: Theme.colors.stroke.strong,
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = Theme.colors.stroke.weak;
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = Theme.colors.secondary;
  }}
>
  +
</button>


                  {/* Tooltip */}
                  {isDialogVisible && isDisabled && userPlan === 'free' && (
          <div
          className="absolute bottom-full left-1/2 transform -translate-x-1/2 w-[12rem] p-2 rounded-2xl shadow-lg z-50"
          style={{
            backgroundColor: Theme.colors.stroke.weak,
            color: Theme.colors.text.default,
          }}
        >
          <p className="text-sm text-center" style={{ color: Theme.colors.text.weak }}>
            Add new section.
          </p>
        </div>
        
                  )}
                  {/* Tooltip */}
                  {isDialogVisible && userPlan !== 'free' && (
       <div
       className="absolute bottom-full left-1/2 transform -translate-x-1/2 w-[10rem] p-2 rounded-2xl shadow-lg z-50"
       style={{
         backgroundColor: Theme.colors.stroke.weak, // #E1E3E5
         color: Theme.colors.text.default,          // #000000
       }}
     >
       <p
         className="text-sm text-center"
         style={{ color: Theme.colors.text.weak }}   // #5D5F61
       >
         Add new section.
       </p>
     </div>
     
                  )}
                </div>

                {/* Right Line */}
                <div
  className="flex-grow h-px"
  style={{ backgroundColor: Theme.colors.stroke.weak }}
></div>

              </div>
            </li>

            {/* Input for New Outline */}
            {inputIndex === idx && (
              <div className="mt-2 flex items-center space-x-2">
                <div className="relative flex w-full max-w-xs">
                <input
  type="text"
  value={newOutline}
  onChange={(e) => setNewOutline(e.target.value)}
  className="block w-full p-2 rounded-lg"
  style={{
    border: `1px solid ${Theme.colors.stroke.weak}`,
    color: Theme.colors.text.strong,
    backgroundColor: Theme.colors.background,
    fontFamily: Theme.font.family,
  }}
  placeholder="New Outline"
/>

                  <div className="absolute inset-y-0 right-2 flex items-center space-x-1">
                  <button
  onClick={() => handleAddOutline(idx)}
  disabled={!newOutline.trim() || newOutlineLoading}
  className={`
    ${
      !newOutline.trim() || newOutlineLoading
        ? 'opacity-20 cursor-not-allowed'
        : 'hover:underline'
    }
  `}
  style={{
    color: Theme.colors.button.primary,
  }}
>
                      {newOutlineLoading && ''}
                      <FaCheck
  className={`${
    !newOutline.trim() || newOutlineLoading ? 'opacity-20' : ''
  }`}
  style={{ color: Theme.colors.button.primary }}
/>

                    </button>
                    <button
  onClick={() => {
    setInputIndex(null);
    setNewOutline('');
  }}
  className="text-sm"
  style={{ color: Theme.colors.stroke.strong }}
>
  <FaTimes
    className="text-base"
    style={{ color: Theme.colors.stroke.strong }}
  />
</button>

                  </div>
                </div>
              </div>
            )}
          </React.Fragment>
        ))}
      </ul>

      {/* Pricing Modal */}
      {isPricingModalOpen && (
        <PricingModal
          closeModal={() => setIsPricingModalOpen(false)}
          heading="Subscription Plans"
          monthlyPlanAmount={monthlyPlanAmount}
          yearlyPlanAmount={yearlyPlanAmount}
          currency={currency!}
          yearlyPlanId={yearlyPlanId!}
          monthlyPlanId={monthlyPlanId!}
          authToken={authToken!}
          orgId={orgId!}
          subscriptionId={subscriptionId}
        />
      )}
      <GuidedTour />
      <GuidedTourMobile />
    </div>
  )
}

export default Sidebar
